// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"b36f24ef","516":"e496d8bf","580":"0c8dff8d","598":"32331c6b"}[chunkId] + ".chunk.css";
};